import React from "react";
import { ModalProps } from "../interfaces";

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  maxWidth,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[8888]  flex items-center justify-center">
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div
        className={`relative max-h-[100vh] w-[100vw] overflow-y-auto bg-white  p-4 shadow-xl sm:max-h-[90vh] ${
          maxWidth ? `sm:w-[450px]` : "sm:w-[60vw]  lg:w-[45vw]"
        }  sm:min-w-[400px] sm:rounded-3xl sm:p-6`}
      >
        {children}
      </div>
    </div>
  );
};
